module.exports = __webpack_public_path__ + "img/vjorngard-logo.f135aa76.jpg";